export default function TermsPage() {
    return (
        <div className="min-h-[70vh]" data-testid="terms-page">
            <div className="bg-card border-b border-border">
                <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20">
                    <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Legal</p>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-foreground tracking-tight mb-4">
                        Terms & Conditions
                    </h1>
                </div>
            </div>

            <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20 max-w-3xl">
                <div className="space-y-8 text-muted-foreground text-sm leading-relaxed">
                    <p>
                        By purchasing from Dry Ice Marketplace, the customer agrees to all terms, policies, and invoice conditions provided at the time of sale.
                    </p>

                    <p>
                        Equipment specifications, pricing, and availability may change without notice.
                    </p>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Customers are responsible for:</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Verifying electrical and air compressor requirements</li>
                            <li>Proper machine operation</li>
                            <li>Compliance with local safety regulations</li>
                        </ul>
                    </div>

                    <p>
                        Dry Ice Marketplace acts as a distributor and marketplace platform for equipment manufacturers and sellers. Sale, distribution, and service are provided by Dry Ice Bulls LLC.
                    </p>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Payment Terms</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>All prices are listed in US Dollars (USD).</li>
                            <li>Wire transfer and ACH payments carry no additional processing fees.</li>
                            <li>A mandatory <span className="text-foreground font-bold">3.5% processing surcharge</span> applies to all credit card transactions processed through Wave Payments.</li>
                            <li><span className="text-foreground font-bold">Credit card processing surcharges are strictly non-refundable</span>, even in the event of order cancellation or return.</li>
                            <li>High-ticket credit card purchases require a signed Credit Card Authorization Form before equipment dispatch.</li>
                            <li>Equipment paid by wire transfer is reserved for 72 business hours pending receipt of funds.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Shipping & Delivery</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>All machinery ships via insured commercial freight to the 48 lower states.</li>
                            <li>Standard stock delivery: within 10 business days.</li>
                            <li>Custom factory orders: 14-21 business days.</li>
                            <li>Customer is responsible for providing adequate receiving facilities (forklift, commercial address, etc.).</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Returns & Warranties</h2>
                        <p>All machinery sales are final. Standard original manufacturer warranties apply. See our <a href="/return-policy" className="text-primary hover:underline">Returns & Refunds Policy</a> for full details.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
